import React from "react";
import logo_white from "../upload/logo_white3.png";
import { useLoader } from "../context/LoaderContext";

const Loader = () => {
  const { loading } = useLoader();
  return (
    <>
      {loading && (
        // <div style={{ background: "#000", height: "100dvh" }}>
          <div
            id="loftloader-wrapper"
            className="pl-imgloading"
            data-show-close-time="15000"
            data-max-load-time="0"
          >
            <div className="loader-inner">
              <div id="loader" style={{ width: "184.76px", height: "160px" }}>
                <div className="imgloading-container">
                  <span
                    style={{
                      backgroundImage: `url(${logo_white})`,
                      width: "184.76px",
                      height: "160px",
                    }}
                  ></span>
                </div>
                <img
                  data-no-lazy="1"
                  className="skip-lazy"
                  alt="loader"
                  src={logo_white}
                  style={{ width: "184.76px", height: "160px" }}
                />
              </div>
            </div>
            <div className="loader-section section-fade"></div>
            <div className="loader-close-button" style={{ display: "none" }}>
              <span className="screen-reader-text">Close</span>
            </div>
            <div className="custom-gradient" style={{ zIndex: "10000" }}></div>
          </div>
        // </div>
      )}
    </>
  );
};

export default Loader;
